import { Normalizer } from 'scenes/Form/components/SetupEmailForm/normalize';

export const ACTION = {
  FORM_DATA_INIT: 'FORM_DATA_INIT',
  FORM_DATA_UPDATE: 'FORM_DATA_UPDATE',

  ATTACHMENTS_SAVE: 'ATTACHMENTS_SAVE',
  ATTACHMENTS_DELETE_REQUEST: 'ATTACHMENTS_DELETE_REQUEST',
  ATTACHMENTS_DELETE_SUCCESS: 'ATTACHMENTS_DELETE_SUCCESS',

  REQUIREMENTS_REQUEST: 'REQUIREMENTS_DELETE_REQUEST',
  REQUIREMENTS_REQUEST_FAIL: 'REQUIREMENTS_REQUEST_FAIL',
  REQUIREMENTS_REMOVE_SUCCESS: 'REQUIREMENTS_REMOVE_SUCCESS',
  REQUIREMENTS_UPDATE_SUCCESS: 'REQUIREMENTS_UPDATE_SUCCESS',
  REQUIREMENTS_CREATE_SUCCESS: 'REQUIREMENTS_CREATE_SUCCESS',
};

export const reducer = (state, action) => {
  const { type, data } = action;

  switch (type) {
    case ACTION.FORM_DATA_INIT: {
      return Normalizer.fetch({ ...data, init: true });
    }

    case ACTION.FORM_DATA_UPDATE: {
      const nextState = Object.assign({}, data);
      delete nextState.attachments;
      return Normalizer.fetch({ ...state, ...nextState, init: true });
    }

    case ACTION.ATTACHMENTS_DELETE_REQUEST: {
      return {
        ...state,
        attachments: state.attachments.map(attach =>
          attach.id === data
            ? {
                ...attach,
                disabled: true,
              }
            : attach
        ),
      };
    }

    case ACTION.ATTACHMENTS_DELETE_SUCCESS: {
      const attachments = state.attachments.filter(
        attach => attach.id !== data
      );
      return { ...state, attachments };
    }

    case ACTION.ATTACHMENTS_SAVE: {
      return {
        ...state,
        attachments:
          state.attachments && state.attachments.length > 0
            ? [...state.attachments, data]
            : [data],
      };
    }

    case ACTION.REQUIREMENTS_REQUEST: {
      return {
        ...state,
        requirements: state.requirements.map(req =>
          req.ProcessEmailSetupReqID === data
            ? {
                ...req,
                disabled: true,
              }
            : req
        ),
      };
    }

    case ACTION.REQUIREMENTS_REQUEST_FAIL: {
      return {
        ...state,
        requirements: state.requirements.map(req =>
          req.ProcessEmailSetupReqID === data
            ? {
                ...req,
                disabled: false,
              }
            : req
        ),
      };
    }

    case ACTION.REQUIREMENTS_REMOVE_SUCCESS: {
      return {
        ...state,
        requirements: state.requirements.filter(
          req => req.ProcessEmailSetupReqID !== data
        ),
      };
    }

    case ACTION.REQUIREMENTS_CREATE_SUCCESS: {
      return {
        ...state,
        requirements:
          state.requirements && state.requirements.length > 0
            ? [...state.requirements, data]
            : [data],
      };
    }

    case ACTION.REQUIREMENTS_UPDATE_SUCCESS: {
      return {
        ...state,
        requirements:
          state.requirements && state.requirements.length > 0
            ? state.requirements.map(req =>
                req.ProcessEmailSetupReqID === data.ProcessEmailSetupReqID
                  ? data
                  : req
              )
            : [data],
      };
    }

    default:
      return state;
  }
};
